import Isotope from "isotope-layout";

const tilesContainerId = 'lbht-walks-tiles';
const tilesFilterId = 'walks-filters';
const tilesSelector = '.walks-selector';

let tilesContainerElement;
let tilesFilterElement;

// Plain Javascript DOM callback(s)
let callback = function(){
  // Handler when the DOM is fully loaded

  // get the element to for the Walks Tiles and Filter
  tilesContainerElement = document.getElementById(tilesContainerId);
  tilesFilterElement = document.getElementById(tilesFilterId);

  // create a new isoTope object with the new set of tiles
  let isoTopeObject = new Isotope( tilesContainerElement, {
    itemSelector: tilesSelector,
    layoutMode: 'fitRows',
  });

  // set the on-click events for the filter items
  const onClickFunction = isoFilterSelectFunc(isoTopeObject);
  const lis = tilesFilterElement.querySelectorAll('li');
  lis.forEach(element => {
    element.addEventListener('click', function() { onClickFunction(this) });
  });

  // creates a closure for the filter onclick events
  // the global isoTope object is used by the closure
  function isoFilterSelectFunc(isoTopeObj) {
    return function(element) {
      element.parentElement.querySelectorAll('li').forEach(e => {e.classList.remove("active");});
      element.classList.add("active");

      let filterValue = element.getAttribute('data-filter');
      isoTopeObj.arrange({filter: filterValue});
    };
  }
  
};
// End of DOM Callback Function(s)

if (
    document.readyState === "complete" ||
    (document.readyState !== "loading" && !document.documentElement.doScroll)
) {
  callback();
} else {
  document.addEventListener("DOMContentLoaded", callback);
}

